/** 行情 symbol 標準化（與後端 subscribeThumb 一致）。 */
export function normalizeSymbolCode(code) {
  return String(code || '').trim().toUpperCase();
}

export function normalizeSymbolCodes(codes) {
  return [...new Set((codes || []).map(normalizeSymbolCode).filter(Boolean))];
}

/** 列表現價格式化。 */
export function formatThumbPrice(value, digits = 4) {
  if (value == null || value === '') {
    return '—';
  }
  const num = Number(value);
  if (Number.isNaN(num)) {
    return String(value);
  }
  return num.toLocaleString(undefined, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
}

/** 成交量格式化（對齊 thumb.volume）。 */
export function formatThumbVolume(value) {
  if (value == null || value === '') {
    return '—';
  }
  const num = Number(value);
  if (Number.isNaN(num)) {
    return String(value);
  }
  return num.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 5,
  });
}

/** 依 open / price 計算漲跌與百分比（Socket thumb 欄位）。 */
export function formatThumbChange(thumb) {
  if (!thumb?.price || !thumb?.open) {
    return { text: '—', positive: true };
  }
  const price = Number(thumb.price);
  const open = Number(thumb.open);
  if (Number.isNaN(price) || Number.isNaN(open) || open === 0) {
    return { text: '—', positive: true };
  }
  const diff = price - open;
  const pct = (diff / open) * 100;
  const sign = diff >= 0 ? '+' : '';
  return {
    text: `${sign} ${Math.abs(diff).toFixed(2)} (${sign}${pct.toFixed(2)}%)`,
    positive: diff >= 0,
  };
}
